import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_ACCCATEGORY,
  DELETE_ACCCATEGORY,
  UPDATE_ACCCATEGORY,
  ADD_NEW_ACCCATEGORY,
} from "./actionType";

import {
  getAccCategorySuccess,
  getAccCategoryFail,
  deleteAccCategorySuccess,
  deleteAccCategoryFail,
  updateAccCategorySuccess,
  updateAccCategoryFail,
  addAccCategorySuccess,
  addAccCategoryFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveAccCategoryApi,
  getAccCategoryApi,
  updateAccCategoryApi,
  deleteAccCategoryApi,
  addNewAccCategoryApi
} from "../../helpers/backend_helper";

function* getAccCategory({ payload: accCategory }) {
  try {
    const response = yield call(getAccCategoryApi, accCategory);
    yield put(getAccCategorySuccess(GET_ACCCATEGORY, response.data));
  } catch (error) {
    yield put(getAccCategoryFail(GET_ACCCATEGORY, error));
  }
}

function* onUpdateAccCategory({ payload: accCategory }) {
  try {
    if (accCategory.setApprove) {
      const response = yield call(approveAccCategoryApi, accCategory);
      yield put(updateAccCategorySuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateAccCategoryApi, accCategory);
      yield put(updateAccCategorySuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateAccCategoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteAccCategory({ payload: accCategory }) {
  try {
    const response = yield call(deleteAccCategoryApi, accCategory);
    yield put(deleteAccCategorySuccess({ accCategory, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteAccCategoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewAccCategory({ payload: accCategory }) {
  try {
    const response = yield call(addNewAccCategoryApi, accCategory);
    yield put(addAccCategorySuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addAccCategoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetAccCategory() {
  yield takeEvery(GET_ACCCATEGORY, getAccCategory);
}

export function* watchUpdateAccCategory() {
  yield takeEvery(UPDATE_ACCCATEGORY, onUpdateAccCategory);
}

export function* watchDeleteAccCategory() {
  yield takeEvery(DELETE_ACCCATEGORY, onDeleteAccCategory);
}

export function* watchAddNewAccCategory() {
  yield takeEvery(ADD_NEW_ACCCATEGORY, onAddNewAccCategory);
}

function* accCategorySaga() {
  yield all([
    fork(watchGetAccCategory),
    fork(watchDeleteAccCategory),
    fork(watchUpdateAccCategory),
    fork(watchAddNewAccCategory)
  ]);
}

export default accCategorySaga;
